/* RESPONSIBLE TEAM: team-email */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import ManageTeammatesRoute from 'embercom/routes/apps/app/settings/base/manage-teammates-route';
import type Transition from '@ember/routing/transition';
import type Store from '@ember-data/store';
import { hash } from 'rsvp';

export default class CsvImportRoute extends ManageTeammatesRoute {
  @service declare appService: AppService;
  @service declare store: Store;

  analytics = {
    section: 'settings',
    place: 'teammate_invite_csv_import',
  };

  beforeModel(transition: Transition) {
    if (!transition.data.parsedCsv) {
      this.transitionTo('apps.app.settings.workspace.teammates');
    }
  }

  async model(_params: $TSFixMe, transition: Transition) {
    return hash({
      columns: this._columnsFromParsedCsv(transition.data.parsedCsv),
      file: transition.data.file,
      existingRoles: this.store.findAll('role', { reload: true }),
      existingTeammates: this.store.findAll('admin', { reload: true }),
      existingInvites: this.store.findAll('invited-admin', { reload: true }),
      existingTeamInboxes: this.store.findAll('team', { reload: true }),
    });
  }

  _columnsFromParsedCsv(parsedCsv: $TSFixMe) {
    // convert rows of columns to columns of rows
    let rows = parsedCsv.data;
    let columns = new Array(rows[0].length);
    for (let col = 0; col < columns.length; col++) {
      columns[col] = new Array(rows.length);
      for (let row = 0; row < columns[col].length; row++) {
        columns[col][row] = rows[row][col];
      }
    }
    return columns;
  }

  setupController(controller: any, model: any) {
    super.setupController(controller, model);
    // Trigger email validation when controller is set up
    controller.processValues();
  }
}
